export default __webpack_public_path__ + "static/media/Mask Group 11.cf684742.png";